
export const AppToDoListJuanGp = () => window.location.href = 'https://to-do-list-juangp.web.app'